export default function ColourItem({
  colour,
  idx,
  formData,
  setFormData,
  setColourFormData,
}) {
  // console.log(colour)

  function handleClick(evt) {
    // console.log(evt.target.id)
    const colourId = evt.target.id;
    if (formData.colours.includes(colourId)) {
      const newFormData = { ...formData };
      const index = newFormData.colours.indexOf(colourId);
      newFormData.colours.splice(index, 1);
      setFormData(newFormData);
      // console.log(index)
      // console.log(formData)
    } else {
      const newFormData = { ...formData };
      newFormData.colours.push(colourId);
      setFormData(newFormData);
      // console.log(formData)
    }
    if (setColourFormData) setColourFormData("");
  }
  return (
    <p
      key={idx}
      id={colour._id}
      onClick={handleClick}
      className={`border rounded-full px-3 py-1 text-sm cursor-pointer transition-colors ${formData.colours.includes(colour._id) ? "bg-stone-800 text-white border-stone-800" : "bg-stone-100 text-stone-700 border-stone-300 hover:border-stone-500"}`}
    >
      {colour.colourName}
    </p>
    // <p></p>
  );
}
